module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.numPages), function(i) {
    return _c('pdf', {
      key: i,
      staticStyle: {
        "width": "60%",
        "height": "60%",
        "margin": "0 auto",
        "padding-top": "30px"
      },
      attrs: {
        "src": _vm.src,
        "page": i
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-668b5fea","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Order/pdfPreview.vue
// module id = 651
// module chunks = 0